export default "__VITE_ASSET__C0Qy3iam__"